import swal from "sweetalert";
import Api from "./Api";

const useUpdate = (url = ``, inputs = {}) => {
  return new Promise((resolve, reject) => {
    let data = JSON.stringify(inputs);
    Api.put(url, data)
      .then((response) => {
        if (response.data.resultCode === "00") {
          swal("", "updated", "success");
          resolve(response.data); // Ensure this returns the data
        } else {
          swal("", response.data.errors, "error");
          //reject(response.data);
        }
      }, (error) => {
        swal("", "Failed", "error");
        reject(error);
      });
  });
};

export default useUpdate;
